import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

import { fontsMixin } from './fonts';

const GlobalStyle = createGlobalStyle`
  ${normalize}

  ${fontsMixin}

  body {
    margin: 0;
    padding: 0;
  }

  html {
    margin: 0;
    padding: 0;

    font-family: Main, sans-serif;
  }
`;

export default GlobalStyle;
